import type { TFunction } from 'i18next';
import {
  Payment,
  type ProcessingTime,
  ProcessingTimeType,
} from 'payments-lib-types';

export const bankTransferFiatBrands = [
  'APM126~bank-transfer-local-apm126',
  'wire',
  'mifinity_au',
  'bank_transfer',
  'APM37~pay-via-bank-apm37',
  'mifinity_sepa',
  'fixipay',
  'APM126~bank-transfer-iban-apm126',
  'APM35~payanybank-australia-apm35',
  'APM35~payanybank-new-zealand-apm35',
  'APM35~payanybank-europe-apm35',
  'APM126~banktransfer-local-norway-apm126',
];

export const getWithdrawProcessingMessage = (
  brand: string,
  type: Payment.MethodType,
  processingTime: ProcessingTime,
  t: TFunction
) => {
  switch (true) {
    case type === Payment.MethodType.Cards:
      return `1 — ${t('withdraw:bankingDays', { value: 3 })}`;

    case bankTransferFiatBrands.includes(brand):
      return `3 — ${t('withdraw:bankingDays', { value: 5 })}`;

    case type === Payment.MethodType.BankTransfer:
      return `3 — ${t('withdraw:bankingDays', { value: 5 })}`;

    case type === Payment.MethodType.Crypto:
    case processingTime.type === ProcessingTimeType.Instant:
      return `${t('withdraw:upTo')} ${t('withdraw:hours', { value: 3 })}`;

    case processingTime.type === ProcessingTimeType.Range:
      return `${processingTime.minDays} — ${t('withdraw:days', { value: processingTime.maxDays })}`;

    case processingTime.type === ProcessingTimeType.None:
      return null;

    default:
      return `${t('withdraw:upTo')} ${t('withdraw:days', { value: 3 })}`;
  }
};
